(function() {
    "use strict";

    angular.module('app').controller('LanguageController', LanguageController);
    LanguageController.$inject = ['$scope', '$http', 'settingsService', 'codesService', 'translationsService'];
    function LanguageController($scope, $http, settingsService, codesService, translationsService) {
        codesService.loadAllCodes();

        $scope.changeLanguage = function (language) {
            if (language) {
                $http.get(settingsService.applicationPath + 'Culture/Change?culture=' + language)
                    .then(() => {
                        translationsService.loadTranslations(() => {
                            location.reload();
                        });

                    }, () => {
                        translationsService.loadTranslations(() => {
                            location.reload();
                        });
                    });
            }
        };
    }
})();